require("typeface-roboto")
require("typeface-roboto-condensed")

export const onClientEntry = () => {
  if (!(`IntersectionObserver` in window)) {
    require('intersection-observer');
    console.log(`# IntersectionObserver is polyfilled!`)
  }
}
